// BillingManagement.tsx
import React from "react";
import { ManageBilling } from "billing/components/ManageBilling";
import { useAuth } from "providers/authProvider";

export const BillingManagement: React.FC = () => {
  const { user } = useAuth();
  const email = user?.email ?? null;

  // Treat "no user yet" as loading state
  if (!user) {
    return (
      <div className="page-container billing-management-page">
        <div className="billing-card">
          <p>Loading your account details...</p>
        </div>
      </div>
    );
  }

  // User exists but has no email
  if (!email) {
    return (
      <div className="page-container billing-management-page">
        <div className="billing-card">
          <h2 className="billing-card__title">Billing Management</h2>
          <p>
            We could not find an email associated with your account. Please log in again or contact
            support.
          </p>
        </div>
      </div>
    );
  }

  // Happy path
  return (
    <div className="page-container billing-management-page">
      <ManageBilling email={email} />
    </div>
  );
};
